import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatDate(timestamp: number): string {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now.getTime() - date.getTime();

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;

    return date.toLocaleDateString();
}

export function formatTime(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
}

export function truncate(str: string, length: number): string {
    if (str.length <= length) return str;
    return str.slice(0, length) + '...';
}

/**
 * Parse message content and extract @mention contact IDs
 * @param content - The message content to parse
 * @returns Array of unique contact IDs mentioned in the message
 */
export function parseMentions(content: string): string[] {
    // Match @mentions with the format: @[contact-id]
    // The ID format is: contact-{timestamp}-{random}
    const mentionRegex = /@\[(contact-\d+-[a-z0-9]+)\]/g;
    const matches = content.matchAll(mentionRegex);

    // Extract unique contact IDs
    const contactIds = new Set<string>();
    for (const match of matches) {
        contactIds.add(match[1]);
    }

    return Array.from(contactIds);
}
